if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      // console.log(MutationList)
      for (let item of MutationList) {
        if (item.target.id === "cart-icon-bubble") {
          handleTEBox();
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);
  const pageType =
    window.ShopifyAnalytics &&
    window.ShopifyAnalytics.meta &&
    window.ShopifyAnalytics.meta.page &&
    window.ShopifyAnalytics.meta.page.pageType;

  if (pageType !== "cart") {
    let counter = 0;
    const interval = setInterval(() => {
      const footerPrice = document.querySelector(
        ".cart-drawer__checkout-buttons"
      );

      if (footerPrice) {
        handleTEBox();
        clearInterval(interval);
      } else {
        counter += 100;
        if (counter >= 10000) {
          clearInterval(interval);
        }
      }
    }, 100);
  } else {
    let counter = 0;
    const interval = setInterval(() => {
      const vatInputWrapper = document.querySelector(
        ".bss-b2b-vat-input-wrapper"
      );

      if (vatInputWrapper) {
        handleTEBox();
        clearInterval(interval);
      } else {
        counter += 100;
        if (counter >= 10000) {
          clearInterval(interval);
        }
      }
    }, 100);
  }

  function handleTEBox() {
    const translations = BSS_B2B.te.teTranslations;
    const headerText = document.querySelector(
      ".bss-b2b-translation-vat-form_header_text"
    );
    if (headerText) {
      headerText.innerText = translations.form_header_text;
    }

    const subtitleText = document.querySelector(
      ".bss-b2b-translation-vat-form_subtitle_text"
    );
    if (subtitleText) {
      subtitleText.innerText = translations.form_subtitle_text;
    }

    const successMessages = [
      document.querySelector(".bss-b2b-translation-vat-form_success_message"),
      document.querySelector(
        ".bss-b2b-translation-vat-form_success_message_uk"
      ),
      document.querySelector(
        ".bss-b2b-translation-vat-form_success_message_abn"
      ),
      document.querySelector(
        ".bss-b2b-translation-vat-form_success_message_gst"
      ),
      document.querySelector(
        ".bss-b2b-translation-vat-form_success_message_us_ein"
      ),
    ];

    successMessages.forEach((msg, index) => {
      if (msg) {
        switch (index) {
          case 0:
            msg.innerText = translations.form_success_message || "";
            break;
          case 1:
            msg.innerText = translations.form_success_message_uk || "";
            break;
          case 2:
            msg.innerText = translations.form_success_message_abn || "";
            break;
          case 3:
            msg.innerText = translations.form_success_message_gst || "";
            break;
          case 4:
            msg.innerText = translations.form_success_message_us_ein || "";
            break;
        }
      }
    });

    const errorMessages = [
      document.querySelector(".bss-b2b-translation-vat-form_error_message"),
      document.querySelector(".bss-b2b-translation-vat-form_error_message_uk"),
      document.querySelector(".bss-b2b-translation-vat-form_error_message_abn"),
      document.querySelector(".bss-b2b-translation-vat-form_error_message_gst"),
      document.querySelector(
        ".bss-b2b-translation-vat-form_error_message_us_ein"
      ),
      document.querySelector(
        ".bss-b2b-translation-vat-form_validate_country_code_message"
      ),
    ];

    errorMessages.forEach((msg, index) => {
      if (msg) {
        switch (index) {
          case 0:
            msg.innerText = translations.form_error_message || "";
            break;
          case 1:
            msg.innerText = translations.form_error_message_uk || "";
            break;
          case 2:
            msg.innerText = translations.form_error_message_abn || "";
            break;
          case 3:
            msg.innerText = translations.form_error_message_gst || "";
            break;
          case 4:
            msg.innerText = translations.form_error_message_us_ein || "";
            break;
          case 5:
            msg.innerText =
              translations.form_validate_country_code_message || "";
            break;
        }
      }
    });
  }
}

(() => {
  document.addEventListener("DOMContentLoaded", () => {
      const isCart = window.location.pathname === '/cart';
      if (isCart) {
          const checkoutElements = document.querySelectorAll(`[name="checkout"]`);
          checkoutElements.forEach(checkout => {
              checkout.addEventListener("click", (e) => {
                  setCheckoutBtnLoading(true, checkoutElements);
              }, 1);
          });
      }
  });
  function setCheckoutBtnLoading(status, checkoutElements, checkoutSelector = '', productForm) {
    const loaderAttr = 'bss-b2b-checkout-loader';
    const defaultAttr = 'bss-b2b-default-checkout';

    if (status) {
        const bssLoader = `<div style="display: flex;"><div class="bss-loader" style="display: block;"></div></div>`;
        checkoutElements.forEach((checkoutElem) => {
            if (checkoutElem instanceof HTMLElement) {
                const checkoutElemLoader = checkoutElem.cloneNode(true);
                if (checkoutElemLoader instanceof HTMLButtonElement) {
                    checkoutElemLoader.disabled = true;
                } else {
                    checkoutElemLoader.style.cursor = 'none';
                }
                checkoutElemLoader.setAttribute(loaderAttr, 'true');
                checkoutElemLoader.innerHTML = bssLoader;
                checkoutElem.style.setProperty('display', 'none', 'important');
                checkoutElem.after(checkoutElemLoader);
                checkoutElem.setAttribute(defaultAttr, 'true');
            }
        });
    } else {
        document.querySelectorAll(`[${loaderAttr}]`).forEach(el => el.remove());

        let isShow = true;
        if (productForm) {
            const defaultBIN = productForm.querySelector('[bss-b2b-default-buy-now]');
            if (defaultBIN && window.getComputedStyle(defaultBIN).display === 'block') {
                isShow = false;
            }
        }

        if (isShow) {
            document.querySelectorAll(`[${defaultAttr}]${checkoutSelector}`)
                .forEach((item) => {
                    item.style.display = 'block';
                });
        }
    }
}
})();